import Component from './ReactSimpleChatComponent';

import { connect } from 'react-redux';
// facon tuto
import { addFlowItem } from '../../redux/_AppStore';
// facon JDIAZ
// import { DISPATCH } from '../../ReactSimpleChat/redux/_StepsStore';

// on map le state de redux sur les props du composant
const mapStateToProps = (state) => {
  const {globalKey,flow} = state.app;

  // console.log('ReactSimpleChatComponent - ',{steps});
  return {
    globalKey,
    flow,
  };
};

// on map le dispatch de redux sur les props du composant
const mapDispatchToProps = (dispatch) => {
  return {
    // facon tuto
    addFlowItem: (newFlowItem) => dispatch(addFlowItem(newFlowItem)),
    // facon JDIAZ
    // addStep: (newStep) => dispatch(DISPATCH.addStep(newStep)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Component);
